import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Linkedin } from 'lucide-react';

const COL_HEALTH = [
  { label: 'Sanità & Innovazione',          to: '/sanita' },
  { label: 'AI in Sanità',                  to: '/sanita/ai' },
  { label: 'Longevity',                     to: '/longevity' },
  { label: 'Medical Tourism',               to: '/med-tourism' },
  { label: 'Agevolazioni e Finanziamenti',  to: '/agevolazioni-finanziamenti' },
  { label: 'Sviluppo Impresa',              to: '/sviluppo-impresa' },
  { label: 'Ricerca & Sviluppo',            to: '/ricerca-sviluppo' },
  { label: 'Formazione',                    to: '/formazione' },
];

const COL_INVEST = [
  { label: 'Investimenti',          to: '/investimenti' },
  { label: 'Startup & PoC',         to: '/startup-poc' },
  { label: 'M&A e Due Diligence',   to: '/ma-due-diligence' },
  { label: 'Nuove Infrastrutture',  to: '/nuove-infrastrutture' },
  { label: 'Club Deal',             to: '/club-deal' },
  { label: 'Sviluppo Globale',      to: '/progetti-esteri' },
];

const COL_COMPANY = [
  { label: 'Chi Siamo', to: '/chi-siamo' },
  { label: 'Contatti',  to: '/contatti' },
];

const Footer = () => (
  <footer className="bg-[#0d1117] text-white">

    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr_1fr] gap-10 [&>div]:min-w-0">

        {/* Brand */}
        <div className="flex flex-col gap-5">
          <Link to="/" className="font-display font-bold italic text-white text-lg leading-tight">
            EUROPROJECT<span className="text-accent ml-1">CONSULTING</span>
          </Link>
          <p className="text-sm text-white/40 leading-relaxed">
            Consulenza strategica specializzata nel settore sanitario.
            Lavoriamo con imprese, investitori e istituzioni.
          </p>
          <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
            className="w-9 h-9 flex items-center justify-center border border-white/15 text-white/50 hover:border-white/40 hover:text-white transition-all duration-200 self-start"
            aria-label="LinkedIn"
          >
            <Linkedin className="w-4 h-4" />
          </a>
          <div className="flex flex-col gap-3">
            <a
              href="mailto:europroject@europroject.it"
              className="flex items-center gap-2 text-sm text-white/40 hover:text-white transition-colors duration-200 break-words"
            >
              <Mail className="w-4 h-4 shrink-0" />
              europroject@europroject.it
            </a>
            <span className="flex items-start gap-2 text-sm text-white/40">
              <MapPin className="w-4 h-4 shrink-0 mt-0.5" />
              <span className="flex flex-col">
                <span>Piazzale Giulio Cesare, 12</span>
                <span>20145 - Milano (MI)</span>
              </span>
            </span>
          </div>
        </div>

        {/* Health & Wellbeing */}
        <div className="min-w-0">
          <p className="text-[10px] font-bold uppercase tracking-[0.28em] text-white/25 mb-5">Health & Wellbeing</p>
          <ul className="flex flex-col gap-3">
            {COL_HEALTH.map(({ label, to }) => (
              <li key={to}>
                <Link to={to} className="text-sm text-white/55 hover:text-white transition-colors duration-200">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Investimenti */}
        <div className="min-w-0">
          <p className="text-[10px] font-bold uppercase tracking-[0.28em] text-white/25 mb-5">Investimenti</p>
          <ul className="flex flex-col gap-3">
            {COL_INVEST.map(({ label, to }) => (
              <li key={to}>
                <Link to={to} className="text-sm text-white/55 hover:text-white transition-colors duration-200">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Società */}
        <div className="min-w-0">
          <p className="text-[10px] font-bold uppercase tracking-[0.28em] text-white/25 mb-5">Società</p>
          <ul className="flex flex-col gap-3">
            {COL_COMPANY.map(({ label, to }) => (
              <li key={to}>
                <Link to={to} className="text-sm text-white/55 hover:text-white transition-colors duration-200">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

      </div>
    </div>

    {/* Bottom bar */}
    <div className="border-t border-white/8">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <p className="text-xs text-white/25">
          &copy; {new Date().getFullYear()} Europroject Consulting S.r.l. &mdash; P.IVA 00000000000
        </p>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
          <a href="#" className="text-xs text-white/25 hover:text-white/60 transition-colors duration-200">Privacy Policy</a>
          <a href="#" className="text-xs text-white/25 hover:text-white/60 transition-colors duration-200">Cookie Policy</a>
          <a href="#" className="text-xs text-white/25 hover:text-white/60 transition-colors duration-200">Note Legali</a>
        </div>
      </div>
    </div>

  </footer>
);

export default Footer;
